import { SVG } from "../../UI/selector"
import "./ZeroState.scss"
import React from "react"
export default function ZeroState({ icon, text }) {
  return (
    <div className="zero-state-container">
      <SVG src={icon} height={300} />
      <p>{text}</p>
    </div>
  )
}
